/* ============================================================
   STRONGARM BV — main.js
   Mobile drawer + scroll reveal + actief menu-item
   ============================================================ */

(function () {
  // --- Mobile drawer ---
  const toggle = document.querySelector('.menu-toggle');
  const drawer = document.querySelector('.mobile-drawer');
  const closeBtn = document.querySelector('.mobile-drawer__close');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  
  // --- Liquid Glass nav drawer (lg-nav) ---
  const lgToggle = document.getElementById('navToggle');
  const lgDrawer = document.getElementById('navDrawer');
  const lgClose = document.getElementById('navClose');

  function lgOpen() {
    if (lgDrawer) {
      lgDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }
  function lgCloseFn() {
    if (lgDrawer) {
      lgDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (lgToggle) lgToggle.addEventListener('click', lgOpen);
  if (lgClose) lgClose.addEventListener('click', lgCloseFn);
  if (lgDrawer) lgDrawer.addEventListener('click', function(e) {
    if (e.target === lgDrawer) lgCloseFn();
  });
  // Close on link click
  if (lgDrawer) lgDrawer.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', lgCloseFn);
  });

  if (drawer) drawer.addEventListener('click', (e) => {
    if (e.target === drawer) closeDrawer();
  });

  // --- Scroll reveal ---
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  // --- Markeer actief menu-item op basis van bestandsnaam ---
  const path = (location.pathname.split('/').pop() || 'index.html').toLowerCase();
  document.querySelectorAll('.nav a, .mobile-drawer a').forEach((a) => {
    const href = (a.getAttribute('href') || '').toLowerCase();
    if (href === path || (path === '' && href === 'index.html')) {
      a.classList.add('is-active');
    }
  });

  // --- Jaartal in footer ---
  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // --- Scroll-to-top knop ---
  const scrollBtn = document.getElementById('scrollTop');
  if (scrollBtn) {
    const threshold = 400;
    const onScroll = () => {
      if (window.scrollY > threshold) scrollBtn.classList.add('is-visible');
      else scrollBtn.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    scrollBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }

  // --- Contactformulier: simpele client-side feedback ---
  const form = document.querySelector('form[data-contact]');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Verzonden — we nemen contact op';
      }
      form.querySelectorAll('input, textarea, select').forEach((el) => el.setAttribute('disabled', 'true'));
    });
  }

  // --- Video forceren te blijven spelen tijdens scroll ---
  const allVideos = document.querySelectorAll('video');
  function ensurePlaying() {
    allVideos.forEach(function(v) {
      if (v.paused && !v.ended) {
        const p = v.play();
        if (p && p.catch) p.catch(function() {});
      }
    });
  }
  window.addEventListener('scroll', ensurePlaying, { passive: true });
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) ensurePlaying();
  });
  window.addEventListener('focus', ensurePlaying);
  window.addEventListener('pageshow', ensurePlaying);

  // --- Video fade voor page-hero banner ---
  document.querySelectorAll('.page-hero-video').forEach(function(video) {
    var rafId = null, fadingOutRef = false, FADE_MS = 250;
    function readOpacity() { var v = parseFloat(video.style.opacity); return isFinite(v) ? v : 1; }
    function fadeTo(target) {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      var startOpacity = readOpacity();
      if (startOpacity === target) return;
      var start = performance.now();
      function step(now) {
        var t = Math.min(1, (now - start) / FADE_MS);
        video.style.opacity = String(startOpacity + (target - startOpacity) * t);
        if (t < 1) rafId = requestAnimationFrame(step); else rafId = null;
      }
      rafId = requestAnimationFrame(step);
    }
    video.style.opacity = '0';
    function onReady() { fadingOutRef = false; fadeTo(1); }
    if (video.readyState >= 2) onReady();
    else video.addEventListener('loadeddata', onReady, { once: true });
    video.addEventListener('timeupdate', function () {
      if (fadingOutRef) return;
      var dur = video.duration;
      if (!isFinite(dur) || dur <= 0) return;
      if (dur - video.currentTime <= 0.55) { fadingOutRef = true; fadeTo(0); }
    });
    video.addEventListener('ended', function () {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      video.style.opacity = '0';
      setTimeout(function () {
        try { video.currentTime = 0; } catch (e) {}
        var p = video.play(); if (p && p.catch) p.catch(function(){});
        fadingOutRef = false; fadeTo(1);
      }, 100);
    });
  });
})();